import { BasicPersistenceService } from '../../../../../shared/services/BasicPersistenceService';
import { AppApplicationModel } from '../models/AppApplicationModel';
import { DamageFormModel } from '../models/DamageFormModel';
import { CheckForm } from '../../../../../shared/models/view/DamageCheckForm';
import { PersonalDataFormModel } from '../models/PersonalDataFormModel';
import { DocumentsBillsFormModel } from '../models/DocumentsBillsFormModel';

export class AppPersistenceService extends BasicPersistenceService<DamageDeclarationOhcAppDefinition> {

	public getApplicationModel(): AppApplicationModel {
		const dataObject = this.getApplicationObject();
		return AppApplicationModel.createFromObject(dataObject);
	}

	/**
	 * returns the DamageOhcFormModel
	 */
	public getDamageOhcFormModel(): DamageFormModel {
		return this.getApplicationModel().DamageFormModel;
	}

	/**
	 * sets the DamageOhcFormModel
	 */
	public setDamageOhcFormModel(formModel: DamageFormModel): void {
		const applicationModel = this.getApplicationModel();
		applicationModel.DamageFormModel = formModel;
		this.setApplicationModel(applicationModel);
	}


	/**
	 * returns the DocumentsBillsFormModel
	 */
	public getDocumentsBillsOhcFormModel(): DocumentsBillsFormModel {
		return this.getApplicationModel().DocumentsBillsFormModel;
	}

	/**
	 * sets the DocumentsBillsFormModel
	 */
	public setDocumentsBillsOhcFormModel(formModel: DocumentsBillsFormModel): void {
		const applicationModel: AppApplicationModel = this.getApplicationModel();
		applicationModel.DocumentsBillsFormModel = formModel;
		this.setApplicationModel(applicationModel);
	}

	/**
	 * returns the PersonalDataOhcFormModel
	 */
	public getPersonalDataOhcFormModel(): PersonalDataFormModel {
		return this.getApplicationModel().PersonalDataFormModel;
	}

	/**
	 * sets the PersonalDataOhcFormModel
	 */
	public setPersonalDataOhcFormModel(formModel: PersonalDataFormModel): void {
		const applicationModel = this.getApplicationModel();
		applicationModel.PersonalDataFormModel = formModel;
		this.setApplicationModel(applicationModel);
	}

	/**
	 *  returns the CheckOhcFormModel
	 */
	public getCheckFormModelFromStore(): CheckForm {
		return this.getApplicationModel().CheckFormModel;
	}

	/**
	 * sets the CheckOhcFormModel
	 */
	public setCheckFormModelToStore(formModel: CheckForm): void {
		const applicationModel = this.getApplicationModel();
		applicationModel.CheckFormModel = formModel;
		this.setApplicationModel(applicationModel);
	}
}